import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const CyclingWeekly: Site = {
  id: 'cyclingweekly',
  logo: 'svg/cyclingweekly.svg',
  label: 'Cycling Weekly',
  analyticsName: 'cyclingweekly',
  hostname: 'cyclingweekly.com',
  platform: 'progressive',
  selector: `${progressiveVanillaSelector}, .articleBody a`,
};
